"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from "react";
import { useSearchParams } from "next/navigation";
import { useCatalogInfinite } from "@/queries/catalog";
import type { PersonContent } from "@/types/person";
import { buildCatalogConfig } from "./catalogParamsBuilder";
interface Params {
  range: [number, number] | undefined;
  yearType: "gregorian" | "persian";
  enabled?: boolean;
}
export function useSearchCatalog(t0) {
  const $ = _c(22);
  const {
    range,
    yearType,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const searchParams = useSearchParams();
  let t2;
  if ($[0] !== searchParams) {
    t2 = searchParams.toString();
    $[0] = searchParams;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const searchParamString = t2;
  let t3;
  if ($[2] !== range || $[3] !== searchParamString || $[4] !== yearType) {
    t3 = buildCatalogConfig({
      searchParamString,
      range,
      yearType
    });
    $[2] = range;
    $[3] = searchParamString;
    $[4] = yearType;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const config = t3;
  const {
    data: catalogData,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    isError,
    refetch
  } = useCatalogInfinite(config.baseParams, config.initialPage, enabled);
  let t4;
  if ($[6] !== catalogData?.pages) {
    t4 = catalogData?.pages ?? [];
    $[6] = catalogData?.pages;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const pages = t4;
  let t5;
  if ($[8] !== pages) {
    t5 = pages.flatMap(_temp3);
    $[8] = pages;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const items = t5;
  let t6;
  if ($[10] !== fetchNextPage || $[11] !== hasNextPage || $[12] !== isFetchingNextPage) {
    t6 = () => {
      if (hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    };
    $[10] = fetchNextPage;
    $[11] = hasNextPage;
    $[12] = isFetchingNextPage;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const handleLoadMore = t6;
  const t7 = Boolean(hasNextPage);
  let t8;
  if ($[14] !== handleLoadMore || $[15] !== isError || $[16] !== isFetchingNextPage || $[17] !== isLoading || $[18] !== items || $[19] !== refetch || $[20] !== t7) {
    t8 = {
      items,
      isLoading,
      isFetchingNextPage,
      hasNextPage: t7,
      handleLoadMore,
      isError,
      refetch
    };
    $[14] = handleLoadMore;
    $[15] = isError;
    $[16] = isFetchingNextPage;
    $[17] = isLoading;
    $[18] = items;
    $[19] = refetch;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}
function _temp3(page) {
  return (page.data?.items ?? []).map(_temp2);
}
function _temp2(item) {
  const entityType = item.entity_type === "series" ? "series" : "movie";
  return {
    content_type: entityType,
    entity_type: entityType,
    unique_code: item.unique_code || "",
    content_uuid: item.entity_uuid || item.uuid || "",
    poster_url: item.poster_url || item.medias?.find(_temp)?.media_url || "",
    title_fa: item.title_fa || "",
    title_en: item.title_en || "",
    release_date: item.release_date,
    tags: item.tags ?? [],
    persons: item.persons ?? [],
    subtitles: item.subtitles ?? [],
    trailers: item.trailers ?? [],
    medias: item.medias ?? [],
    categories: item.categories ?? []
  };
}
function _temp(m) {
  return m.media_type === "poster_desktop";
}